import React from 'react';
import { Redirect } from 'react-router-dom'; 
import axios from 'axios';
import { ChromePicker } from 'react-color';
import FormWizard from './formWizard.component'; 
import FileUpload from './fileUpload.component';
import DatePicker from 'react-datepicker'; 
import validator from 'validator'
import 'react-datepicker/dist/react-datepicker.css'; 

class formBuilder extends React.Component {
    constructor(props){
        super(props); 
        this.state = {
            formName: '',
            formData: [],
            startDate: new Date(),
            endDate: new Date(),
            fNameRequired: false,
            fNameShow: false,
            lNameRequired: false,
            lNameShow: false,
            emailRequired: false,
            emailShow: false,
            phoneRequired: false,
            phoneShow: false,
            addressRequired: false,
            addressShow: false,
            logoUrl: null,
            backgroundColor: '#f1f1f1',
            formCode: this.codeGenerator(30),
            redirectUrl: '',
            redirectUrlStatus: false,
            redirectUrlMessage: '',
            emailResponses: false,
            responseEmailOne: "",
            responseEmailTwo: "",
            responseEmailThree: "",
            responseEmailFour: "",
            responseEmailFive: "",
            disclaimer: '', 
            customField: '',
            redirect: '' 
        }

        this.handleAddEntry = this.handleAddEntry.bind(this); 
        this.handleSetFormName = this.handleSetFormName.bind(this); 
        this.handleFNameRequire = this.handleFNameRequire.bind(this);
        this.handleFNameShow = this.handleFNameShow.bind(this); 

        this.handleLNameRequire = this.handleLNameRequire.bind(this);
        this.handleLNameShow = this.handleLNameShow.bind(this); 

        this.handleEmailRequire = this.handleEmailRequire.bind(this);
        this.handleEmailShow = this.handleEmailShow.bind(this); 

        this.handlePhoneRequire = this.handlePhoneRequire.bind(this);
        this.handlePhoneShow = this.handlePhoneShow.bind(this); 

        this.handleAddressRequire = this.handleAddressRequire.bind(this); 
        this.handleAddressShow = this.handleAddressShow(this); 

        this.handleBackgroundColor = this.handleBackgroundColor.bind(this); 

        this.handleSave = this.handleSave.bind(this); 
        this.handleRedirectUrl = this.handleRedirectUrl.bind(this); 

        this.handleDisclaimer = this.handleDisclaimer.bind(this); 
        this.handleCustomField = this.handleCustomField.bind(this); 

        this.handleEmailResponses = this.handleEmailResponses.bind(this); 
        this.handleResponseEmailOne = this.handleResponseEmailOne.bind(this); 
        this.handleResponseEmailTwo = this.handleResponseEmailTwo.bind(this); 
        this.handleResponseEmailThree = this.handleResponseEmailThree.bind(this); 
        this.handleResponseEmailFour = this.handleResponseEmailFour.bind(this); 
        this.handleResponseEmailFive = this.handleResponseEmailFive.bind(this); 
    }

    componentDidMount() {
        if (this.props.userdata.editFormData) {
            let data = this.props.userdata.editFormData;

            let json = JSON.parse(data.json); 

            function setTime(time){
                if (time){
                    return new Date(time); 
                }

                if (!time){
                    return new Date(); 
                }
            }

            this.setState({
                formName: json.formName,
                formData: json.formData,
                startDate: setTime(json.startDate),
                endDate: setTime(json.endDate),
                fNameRequired: json.fNameRequired,
                fNameShow: json.fNameShow,
                lNameRequired: json.lNameRequired,
                lNameShow: json.lNameShow,
                emailRequired: json.emailRequired,
                emailShow: json.emailShow,
                phoneRequired: json.phoneRequired,
                phoneShow: json.phoneShow,
                addressRequired: json.addressRequire,
                addressShow: json.addressShow,
                logoUrl: json.logoUrl,
                backgroundColor: json.backgroundColor,
                formCode: json.formCode,
                redirectUrl: json.redirectUrl || '',
                disclaimer: json.disclaimer || '',
                customField: json.customField || '',
                emailResponses: json.emailResponses || false,
                responseEmailOne: json.responseEmailOne || "",
                responseEmailTwo: json.responseEmailTwo || "",
                responseEmailThree: json.responseEmailThree || "",
                responseEmailFour: json.responseEmailFour || "",
                responseEmailFive: json.responseEmailFive || "",
            });
        }

    }

    handleRedirectUrl = (event) => {
        let value = event.target.value; 
        let redirectUrlStatus, redirectUrlMessage; 

        if (validator.isURL(value, {
                protocols: ['http', 'https'], 
                require_protocol: true
            })) {
            console.log("url is valid"); 
            redirectUrlStatus = true; 
            redirectUrlMessage = "URL is valid"
        }else{
            console.log("url is not valid"); 
            redirectUrlStatus = false; 
            redirectUrlMessage = "URL must include http:// or https://"
        }

        this.setState({
            redirectUrl: event.target.value,
            redirectUrlStatus: redirectUrlStatus,
            redirectUrlMessage: redirectUrlMessage
        }); 
    }

    handleDisclaimer = (event) => {
        this.setState({
            disclaimer: event.target.value
        })
    }

    handleCustomField = (event) => {
        this.setState({
            customField: event.target.value
        })
    }

    handleFNameRequire = () => {
        if (this.state.fNameRequired === false){
            this.setState({
                fNameRequired: true,
                fNameShow: true
            });
        }else{
            this.setState({
                fNameRequired: false,
                fNameShow: false
            });
        }
    }

    handleFNameShow = () => {
        if (this.state.fNameRequired != true){
            let x = !this.state.fNameShow;
            this.setState({
                fNameShow: x
            });
        }
    }

    handleLNameRequire = () => {
        if (this.state.lNameRequired === false) {
            this.setState({
                lNameRequired: true,
                lNameShow: true
            });
        } else {
            this.setState({
                lNameRequired: false,
                lNameShow: false
            });
        }
    }

    handleLNameShow = () => {
        if (this.state.lNameRequired != true) {
            let x = !this.state.lNameShow;
            this.setState({
                lNameShow: x
            });
        }
    }

    handleEmailRequire = () => {
        if (this.state.emailRequired === false) {
            this.setState({
                emailRequired: true,
                emailShow: true
            });
        } else {
            this.setState({
                emailRequired: false,
                emailShow: false
            });
        }
    }

    handleEmailShow = () => {
        if (this.state.emailRequired != true) {
            let x = !this.state.emailShow;
            this.setState({
                emailShow: x
            });
        }
    }

    handlePhoneRequire = () => {
        if (this.state.phoneRequired === false) {
            this.setState({
                phoneRequired: true,
                phoneShow: true
            });
        } else {
            this.setState({
                phoneRequired: false,
                phoneShow: false
            });
        }
    }

    handlePhoneShow = () => {
        if (this.state.phoneRequired != true) {
            let x = !this.state.phoneShow;
            this.setState({
                phoneShow: x
            });
        }
    }

    handleAddressRequire = () => {
        if (this.state.addressRequired != true){
            this.setState({
                addressRequired: true, 
                addressShow: true
            }); 
        } else {
            this.setState({
                addressRequired: false,
                addressShow: false
            })
        }
    }

    handleAddressShow = () => {
        if (this.state.addressRequired != true){
            let x = !this.state.addressShow;
            this.setState({
                addressShow: x
            })
        }
    }

    handleStartDateChange = (obj) => {
        this.setState({
            startDate: obj
        }); 
    }

    handleEndDateChange = (obj) => {
        this.setState({
            endDate: obj
        });
    }

    handleBackgroundColor = (color) => {
        this.setState({
            backgroundColor: color.hex
        })
    }

    handleAddEntry = () => {
        let array = this.state.formData; 
        let entry = {
            question: '',
            multipleChoice: false,
            required: false,
            showImageNames: false,
            possibleAnswers: [],
            possibleImageAnswers: []
        }
        array.push(entry);
    
        this.setState({
            formData: array
        }); 
    }

    handleSetFormName = (event) => {
        const cap = (s) => {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
        this.setState({
            formName: cap(event.target.value)
        })
    }

    handleSetQuestion = (event, index) => {
        let entry = this.state.formData[index]; 
        entry.question = event.target.value; 
    }

    handleMultipleChoice = (index) => {
        let entry = this.state.formData[index];
        entry.multipleChoice = !entry.multipleChoice;
        this.setState({});
    }

    handleRequired = (index) => {
        let entry = this.state.formData[index];
        entry.required = !entry.required;
        this.setState({});
    }

    handleYesNo = (index) => {
        let array = this.state.formData[index].possibleAnswers;
        
        if (!array.includes('Yes')){
            array.push('Yes');
            array.push('No');  
        }

        this.setState({}); 
    }

    handleAddPossibleAnswer = (value, index) => {
        this.state.formData[index].possibleImageAnswers = [];
        let array = this.state.formData[index].possibleAnswers;
        let x = value.trim(); 
        if (!array.includes(x)){
            x = x.charAt(0).toUpperCase() + x.slice(1); 
            array.push(x);
        }

        this.setState({});
    }

    handleAddPossibleImageAnswer = (images, index) => {
        let imgs = images.filter(img => img.selected === true);
        this.state.formData[index].possibleAnswers = []; 
        this.state.formData[index].possibleImageAnswers = imgs; 
        this.setState({}); 
    }

    handleDeleteQuestion = (index) => { 
        let array = [...this.state.formData];
        if (index !== -1){
            array.splice(index, 1); 
            this.setState({
                formData: array
            }); 
        }
    }

    deletePossibleAnswer = (answer, index) => {
        let array = this.state.formData[index].possibleAnswers;
        let idx = array.indexOf(answer); 

        if (idx !== -1){
            array.splice(idx, 1);
        }

        this.setState({});
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    handleLogo = (res, state) => {
        if (res.status === 200){
            this.setState({
                logoUrl: this.props.apiurl + '/assets/' + this.props.userdata.userId + '/' + state.selectedFile.name
            });
        }
    }

    codeGenerator = (length) => {
        var result = [];
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result.push(characters.charAt(Math.floor(Math.random() *
                charactersLength)));
        }
        return result.join('');
    }

    handleSave = () => {

        if (this.props.userdata.editFormData !== null){

            //for updating an edit 
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }

            axios.post(this.props.apiurl + '/api/form/update', {
                userId: this.props.userdata.userId,
                name: this.state.formName,
                json: JSON.stringify(this.state),
                type: 'QR Code Form',
                status: 'active',
                formCode: this.state.formCode
            }, {
                headers: headers
            }).then(res => {
                if (res.status === 200) {
                    // console.log(res);
                    this.setState({
                        redirect: <Redirect to="/dashboard"></Redirect> 
                    });
                }
            }).catch(err => {
                console.log(err);
            });

        }else{

            // for initial save
            const headers = {
                'X-Access-Token': this.props.userdata.accessToken
            }
    
            axios.post(this.props.apiurl + '/api/form/add', {
                userId: this.props.userdata.userId,
                name: this.state.formName,
                json: JSON.stringify(this.state),
                type: 'QR Code Form',
                status: 'active',
                formCode: this.state.formCode
            }, {
                headers: headers
            }).then(res => {
                if (res.status === 200) {
                    console.log(res);
                    this.setState({
                        redirect: <Redirect to="/dashboard"></Redirect> 
                    });
                }
            }).catch(err => {
                console.log(err);
            });
        }

    }

    handleCancel = () => {
        this.setState({
            formName: '',
            formData: [],
            startDate: new Date(),
            endDate: new Date(),
            fNameRequired: false,
            fNameShow: false,
            lNameRequired: false,
            lNameShow: false,
            emailRequired: false,
            emailShow: false,
            phoneRequired: false,
            phoneShow: false,
            logoUrl: null,
            backgroundColor: '#f1f1f1',
            formCode: '',
            redirectUrl: ''
        });
    }

    handleShowImageNames = (index) => {
        let entry = this.state.formData[index];
        entry.showImageNames = !entry.showImageNames;
        this.setState({});
    }

    handleEmailResponses = (event) => {
        let value = !this.state.emailResponses; 

        this.setState({
            emailResponses: value
        }); 
        console.log(this.state); 
    }

    handleResponseEmailOne = (event) => {
        this.setState({
            responseEmailOne: event.target.value
        });
    }

    handleResponseEmailTwo = (event) => {
        this.setState({
            responseEmailTwo: event.target.value
        });
    }

    handleResponseEmailThree = (event) => {
        this.setState({
            responseEmailThree: event.target.value
        });
    }

    handleResponseEmailFour = (event) => {
        this.setState({
            responseEmailFour: event.target.value
        });
    }

    handleResponseEmailFive = (event) => {
        this.setState({
            responseEmailFive: event.target.value
        });
    }

    render(props){
        let form = []; 
        let redirect = this.state.redirect; 

        this.state.formData.map((entry, index) =>{
            form.push(
                <div className="mt-2 mb-2" key={index}>
                    <FormWizard
                    userdata={ this.props.userdata }  
                    entry={ entry } 
                    index={ index } 
                    possibleAnswers={ entry.possibleAnswers }
                    possibleImageAnswers={ entry.possibleImageAnswers }
                    question={ entry.question }
                    handleSetQuestion={ this.handleSetQuestion } 
                    handleMultipleChoice={ this.handleMultipleChoice }
                    handleYesNo={ this.handleYesNo }
                    handleRequired={ this.handleRequired }
                    handleAddPossibleAnswer={ this.handleAddPossibleAnswer }
                    handleAddPossibleImageAnswer={ this.handleAddPossibleImageAnswer }
                    handleShowImageNames={ this.handleShowImageNames }
                    deletePossibleAnswer={ this.deletePossibleAnswer }
                    deleteQuestion={ this.handleDeleteQuestion }
                    apiurl={ this.props.apiurl }
                    />
                </div>
            )
        })

        let emailFields = ""; 
        if (this.state.emailResponses === true){
            emailFields =  <div className="row mb-2">
            <div className="col">
                <div className="form-group">
                    <label>Response Email Address One</label>
                    <input type="email" className="form-control" 
                        value={ this.state.responseEmailOne }
                        onKeyPress = { this.handleResponseEmailOne }
                        onChange = { this.handleResponseEmailOne }
                    />
                </div>
                <div className="form-group">
                    <label>Response Email Address Two *Optional</label>
                    <input type="email" className="form-control" 
                        value={ this.state.responseEmailTwo }
                        onKeyPress = { this.handleResponseEmailTwo }
                        onChange = { this.handleResponseEmailTwo }
                    />
                </div>
                <div className="form-group">
                    <label>Response Email Address Three *Optional</label>
                    <input type="email" className="form-control" 
                        value={ this.state.responseEmailThree }
                        onKeyPress = { this.handleResponseEmailThree }
                        onChange = { this.handleResponseEmailThree }
                    />
                </div>
                <div className="form-group">
                    <label>Response Email Address Four *Optional</label>
                    <input type="email" className="form-control" 
                        value={ this.state.responseEmailFour }
                        onKeyPress = { this.handleResponseEmailFour }
                        onChange = { this.handleResponseEmailFour }
                    />
                </div>
                <div className="form-group">
                    <label>Response Email Address Five *Optional</label>
                    <input type="email" className="form-control" 
                        value={ this.state.responseEmailFive }
                        onKeyPress = { this.handleResponseEmailFive }
                        onChange = { this.handleResponseEmailFive }
                    />
                </div>
            </div>
        </div>
        }else{
            emailFields = ""; 
        }

        
        return (
            <div className="container">
                <h3>{ this.Capitalize(this.state.formName) }</h3>
                <small style={{float: "right"}}>Form Code: { this.state.formCode }</small>
                <div className="form-group">
                    <input type="text" className="form-control"
                        value={ this.state.formName }
                        onKeyPress={ this.handleSetFormName }
                        onChange={ this.handleSetFormName } 
                        placeholder="Form Name"/>
                </div>

                <div className="card mb-2">
                    <h5 className="card-header">Logo</h5>
                    <div className="card-body">
                        <FileUpload 
                            userdata={ this.props.userdata } 
                            handlelogo={ this.handleLogo } 
                            logourl={ this.state.logoUrl } 
                            apiurl={ this.props.apiurl }
                        />
                    </div>
                </div>

                <div className="card mb-2">
                    <h5 className="card-header">Background Color</h5>
                    <div className="card-body">
                        <div className="row">
                            <div className="col">
                                <p>The form itself will have a white background. You can select a background color for the page that the form sits on. The default is light grey.</p>
                                <div className="form-group">
                                    <label>Select Background Color</label>
                                    <ChromePicker color={ this.state.backgroundColor } onChangeComplete={ this.handleBackgroundColor }/>
                                    {/* <input type="color" className="form-control" value={ this.state.backgroundColor } onChange={ this.handleBackgroundColor } /> */}
                                </div>
                            </div>
                            <div className="col">

                            </div>
                        </div>
                    </div>
                </div>




                <div className="card mb-2">
                    <h5 className="card-header">Standard Questions</h5>
                    <div className="card-body">
                        <div className="row mb-2">
                            <div className="col">
                                First Name
                            </div>
                            <div className="col">
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.fNameRequired ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleFNameRequire }>Require</button>
                                
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.fNameShow ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleFNameShow }>Show</button>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                Last Name
                            </div>
                            <div className="col">
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.lNameRequired ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleLNameRequire }>Require</button>
                                
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.lNameShow ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleLNameShow }>Show</button>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                Email
                            </div>
                            <div className="col">
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.emailRequired ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleEmailRequire }>Require</button>
                                
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.emailShow ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleEmailShow }>Show</button>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                Phone
                            </div>
                            <div className="col">
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.phoneRequired ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handlePhoneRequire }>Require</button>
                                
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.phoneShow ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handlePhoneShow }>Show</button>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                Address
                            </div>
                            <div className="col">
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.addressRequired ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleAddressRequire }>Require</button>
                                
                                <button 
                                className={'btn btn-sm mr-2 ' + (this.state.addressShow ? 'btn-secondary' : 'btn-outline-secondary')} 
                                onClick={ this.handleAddressShow }>Show</button>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col">
                                <div className="form-group">
                                    <label>Custom Field Label</label>
                                    <small> *Optional. To add a custom field to the form, provide a name for the field here.</small>
                                    <input type="text" className="form-control"
                                        value={ this.state.customField }
                                        onKeyPress = { this.handleCustomField }
                                        onChange = { this.handleCustomField }
                                         />
                                </div>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col">
                                <div className="form-group">
                                    <label>Redirect URL</label> 
                                    <small> *Optional. If you provide a redirect url, please provide the full url including "http://" or "https://". </small>
                                    <input type="text" className={ (this.state.redirectUrlStatus ? 'form-control is-valid' : 'form-control is-invalid') }
                                        value={ this.state.redirectUrl }
                                        onKeyPress = { this.handleRedirectUrl }
                                        onChange = { this.handleRedirectUrl }
                                         />
                                    <div className={ (this.state.redirectUrlStatus ? 'valid-feedback' : 'invalid-feedback') }>{ this.state.redirectUrlMessage }</div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <div className="form-group">
                                    <label>Disclaimer</label>
                                    <small> *Optional.</small>
                                    <textarea class="form-control" rows="3"
                                        value={ this.state.disclaimer }
                                        onKeyPress={ this.handleDisclaimer }
                                        onChange={ this.handleDisclaimer }
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <div className="form-group">
                                    <label>Start Date</label><br />
                                    <DatePicker 
                                        className="form-control"
                                        selected={ this.state.startDate }
                                        onChange={ this.handleStartDateChange }
                                        />
                                </div> 
                            </div>

                            <div className="col">
                                <div className="form-group">
                                    <label>End Date</label><br /> 
                                    <DatePicker 
                                        className="form-control"
                                        selected={ this.state.endDate } 
                                        onChange={ this.handleEndDateChange }
                                        />
                                </div> 
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col">
                                <div className="form-group form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" checked={this.state.emailResponses} onChange={ this.handleEmailResponses }/>
                                    <label className="form-check-label" for="exampleCheck1">Do you want responses emailed to you?</label>
                                </div>
                            </div>
                        </div>
                        {emailFields}
                       
                    </div>
                </div>

                { form }
                <button className="btn btn-outline-secondary" onClick={ this.handleAddEntry } disabled={ this.state.formData.length === 10 }>Add Question</button>

                <button className="btn btn-outline-success ml-2" onClick={ this.handleSave }>Save</button>
                <button className="btn btn-outline-danger ml-2" onClick={ this.handleCancel }>Cancel</button>
                <div style={{ height: "80px" }}></div>
                { redirect }
            </div>
        )
    }
}

export default formBuilder;